module.exports = __webpack_public_path__ + "static/media/15.c0b972f6.jpg";